import { useState } from "react";
import { EyeCloseIcon, EyeIcon } from "../../assets/svg";

export const Input = ({
  label, action, className, placeholder, type,
  mb = true, leftIcon, isRequired = false, value, disabled = false,
  autoComplete, autoCapitalize, autoCorrect,
}: {
  label?: string;
  className?: string;
  placeholder: string;
  type: "email" | "number" | "password" | "text" | "datetime" | "search";
  action: (val: any) => void;
  mb?: boolean;
  isRequired?: boolean;
  leftIcon?: any;
  value?: string | number;
  disabled?: boolean;
  autoComplete?: string;
  autoCapitalize?: string;
  autoCorrect?: string;
}) => {
  const [isShow, setIsShow] = useState(false);

  return (
    <div className={mb ? "mb-4" : ""}>
      {label && (
        <label className="block font-body font-semibold text-slate-700 text-sm mb-1.5">
          {label}
          {isRequired && <span className="text-danger ml-0.5">*</span>}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400">
            {leftIcon}
          </div>
        )}
        <input
          type={isShow ? "text" : type}
          placeholder={placeholder}
          className={`
            w-full h-11 rounded-lg border border-slate-200 bg-white
            font-body text-sm text-slate-800 placeholder:text-slate-400
            px-3 ${leftIcon ? "pl-9" : ""} ${type === "password" ? "pr-10" : ""}
            focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-100
            disabled:bg-slate-50 disabled:cursor-not-allowed disabled:text-slate-400
            transition-all duration-150
            ${className ?? ""}
          `}
          onChange={action}
          required={isRequired}
          value={value}
          disabled={disabled}
          autoComplete={autoComplete}
          autoCapitalize={autoCapitalize}
          autoCorrect={autoCorrect}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={() => setIsShow(!isShow)}
            className="absolute inset-y-0 right-3 flex items-center text-slate-400 hover:text-slate-600 transition-colors"
          >
            {isShow ? <EyeCloseIcon /> : <EyeIcon />}
          </button>
        )}
      </div>
    </div>
  );
};
